import React from 'react';

/**
 * DoubleBookedHelper::renderLeaveRequests()
 *
 * @param leaveRequests
 * @returns {JSX.Element|null}
 */
const renderLeaveRequests = (leaveRequests) => {
    if (!leaveRequests || (!!leaveRequests && leaveRequests.length < 1)) {
        return null;
    }

    return (
        <div className={"toast-section"}>
            <div className={"section-title h5 text-eh-white"}>Leave Requests:</div>
            <ul>
                {leaveRequests.map((leaveRequest) => {
                    let message = leaveRequest.start_at_display+" - "+leaveRequest.end_at_display
                    if (!!leaveRequest.user_name) {
                        message = "["+leaveRequest.user_name+"] "+message;
                    }

                    return (
                        <li key={"leave_request_"+leaveRequest.id}>
                            <a href={route('user.show', {user: leaveRequest.user_id})} className={"text-eh-white"}>{message}</a>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}

/**
 * DoubleBookedHelper::renderDeliveries()
 *
 * @param deliveries
 * @returns {JSX.Element|null}
 */
const renderDeliveries = (deliveries) => {
    if (!deliveries || (!!deliveries && deliveries.length < 1)) {
        return null;
    }

    return (
        <div className={"toast-section"}>
            <div className={"section-title h5 text-eh-white"}>Deliveries:</div>
            <ul>
                {deliveries.map((delivery) => {
                    let message = delivery.job_name+": "+delivery.delivery_at_display;
                    if (!!delivery.user_name) {
                        message = "["+delivery.user_name+"] "+message;
                    }

                    return (
                        <li key={"delivery_"+delivery.id}>
                            <a href={route("job.order.delivery.index", {job: delivery.job_id, order: delivery.order_id}).toString()} className={"text-eh-white"}>{message}</a>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}

/**
 * DoubleBookedHelper::renderInstallations()
 *
 * @param installations
 * @returns {JSX.Element|null}
 */
const renderInstallations = (installations) => {
    if (!installations || (!!installations && installations.length < 1)) {
        return null;
    }

    return (
        <div className={"toast-section"}>
            <div className={"section-title h5 text-eh-white"}>Installations:</div>
            <ul>
                {installations.map((installation) => {
                    let message = installation.job_name+": "+installation.start_at_display+" - "+installation.end_at_display;
                    if (!!installation.user_name) {
                        message = "["+installation.user_name+"] "+message;
                    }

                    return (
                        <li key={"delivery_"+installation.id}>
                            <a href={route('job.order.installation.index', {job: installation.job_id, order: installation.order_id}).toString()} className={"text-eh-white"}>{message}</a>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}

/**
 * DoubleBookedHelper::doubleBookedHelper()
 *
 * @param response
 * @returns {JSX.Element|null}
 */
export const doubleBookedHelper = (response) => {
    if (!!response && !!response.data && !!response.data.double_booked) {
        const { leave_requests, deliveries, installations } = response.data;

        return (
            <div className={"double-booked-toast"}>
                <div className={"toast-title h4 text-eh-white"}>
                    Warning: Double Booking(s)
                </div>
                <div className={"toast-scroller"}>
                    {!!leave_requests && leave_requests.length > 0 ? renderLeaveRequests(leave_requests) : null}
                    {!!deliveries && deliveries.length > 0 ? renderDeliveries(deliveries) : null}
                    {!!installations && installations.length > 0 ? renderInstallations(installations) : null}
                </div>
            </div>
        );
    } else {
        return null;
    }
}
